import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/numberOfActiveMembersBySagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const PeriodType = () => {
  const dispatch = useDispatch();

  const { periodTypeOptions, period_type } = useSelector((state) => {
    const {
      periodTypeOptions,
      selectedFilters: { period_type }
    } = state.numberOfActiveMembersBy;
    return { periodTypeOptions, period_type };
  }, shallowEqual);

  return (
    <MultiSelectDropdown
      options={periodTypeOptions}
      selectedFilters={period_type}
      includeFilter={false}
      numberDisplayed={0}
      onSelectChange={(data) => dispatch(actionCreators.updatePeriodType(data))}
    />
  );
};
export default PeriodType;
